module.exports = __webpack_public_path__ + "img/detalle-patinete.94e98717.png";